export const NAVIGATION_CHANGING = "NAVIGATION_CHANGING";
export const NAVIGATION_CHANGED = "NAVIGATION_CHANGED";
